var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEurope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x938keztaa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#063397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.094 14.15.227.68h.717l-.566.415.188.642-.566-.415-.566.415.227-.642-.566-.415h.717l.188-.68zM12.906 14.15l.226.68h.68l-.567.415.227.642-.566-.415-.566.415.226-.642L12 14.83h.68l.226-.68zM7.094 4.113l.227.68h.717l-.566.415.188.641-.566-.415-.566.415.227-.641-.566-.415h.717l.188-.68zM12.906 4.113l.226.68h.68l-.567.415.227.641-.566-.415-.566.415.226-.641L12 4.793h.68l.226-.68zM15.019 6.227l.226.679h.717l-.566.415.189.68-.566-.416-.566.415.226-.68-.566-.414h.717l.189-.68zM4.981 6.227l.227.679h.679l-.566.415.226.68-.566-.416L4.415 8l.227-.68-.567-.414h.68l.226-.68zM15.019 12.038l.226.68h.717l-.566.414.189.642-.566-.415-.566.415.226-.642-.566-.415h.717l.189-.679zM4.981 12.038l.227.68h.679l-.566.414.226.642-.566-.415-.566.415.227-.642-.567-.415h.68l.226-.679zM10 3.32l.226.68h.68l-.566.415.226.68L10 4.678l-.566.415.226-.679L9.094 4h.68L10 3.32zM10 14.943l.226.642h.68L10.34 16l.226.68-.566-.416-.566.415L9.66 16l-.566-.415h.68l.226-.642zM15.811 9.132l.227.68h.679l-.566.415.226.641-.566-.415-.566.415.227-.641-.604-.415h.717l.226-.68zM4.226 9.132l.19.68h.716l-.566.415.226.641-.566-.415-.566.415.19-.641-.567-.415H4l.226-.68z",
    fill: "#FECB17"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x938keztaa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEurope);
export default __webpack_public_path__ + "static/media/Flag-Europe.14dabb8a50a68c083a65df5b9c02b6cc.svg";
export { ForwardRef as ReactComponent };